var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { memoize } from '../../../../utils/mobx/decorators/memoize';
export class AttachedTraitImport {
    parent;
    constructor(parent) {
        this.parent = parent;
    }
    get at() {
        return this.parent;
    }
    get isTraitImportedFromExternal() {
        return this.at.aspect.persistentAspect !== this.at.trait.aspect;
    }
    get exportingAspect() {
        return this.at.attachedInfo.isTraitImported ? this.at.trait.aspect : null;
    }
    // @computed
    get exportTraitResponsibleForThisAtAppearance() {
        return this.at.aspect.aspectImport.exporttraitsMatchingAspect.find(exporttrait => exporttrait.aspect === this.exportingAspect);
    }
    // @computed
    get exportingPriorityLevel() {
        return ((this.exportTraitResponsibleForThisAtAppearance &&
            this.exportTraitResponsibleForThisAtAppearance.value.priorityLifting) ||
            0);
    }
}
__decorate([
    memoize
], AttachedTraitImport.prototype, "exportingAspect", null);
